module.exports = __webpack_public_path__ + "img/lafia-print-caution.ff2ca3db.png";